import { Core } from "@ancademy/vse-client";
import { Form } from "antd";
import React from "react";
import { DefaultReportConfig, ReportItemType } from "./Play/Report";

export function ReportViewer({ data = [] }: Core.IReportViewerProps) {
  return (
    <div>
      {DefaultReportConfig.map(({ label, type = ReportItemType.textArea }, i) => (
        <Form.Item label={label} key={label}>
          <p>{data[i]}</p>
        </Form.Item>
      ))}
    </div>
  );
}
